import { replaceHash } from '../../../../shared/router/hash/replaceHash';
import { isServerSide } from '../../../../shared/utils/isServerSide';
import { Keyword } from '../../../domain/models';
import { getHashForKeyword } from './getHashForKeyword';

export function setHashByKeyword(keyword?: Keyword) {
	if (isServerSide()) {
		return;
	}

	const hash = getHashForKeyword(keyword);
	replaceHash(hash);
}
